<div [@routerTransition]>
    <sub-header
        [title]="('Products' | localize) + ' ' + ('Details' | localize)"
        [breadcrumbs]="breadcrumbs"
    ></sub-header>

    <div [class]="containerClass">
        <div class="card card-custom gutter-b">
            <div class="card-body">
                <tabset>
                    <tab heading="{{ 'Details' | localize }}">
                        <div class="row mt-3">
                            <div class="col-md-3">
                                <div class="form-group">
                                    <label for="Product_InventoryCode">{{ l('InventoryCode') }} *</label>
                                    <input type="text"
                                           #Product_InventoryCode="ngModel"
                                           id="Product_InventoryCode"
                                           class="form-control"
                                           [(ngModel)]="product.productCode"
                                           name="InventoryCode"
                                           [disabled]="itemCodeAuto"
                                           minlength="0"
                                           maxlength="150"
                                           required />
                                    <validation-messages [formCtrl]="Product_InventoryCode"></validation-messages>
                                </div>
                            </div>
                            <div class="col-md-3">
                                <div class="form-group">
                                    <label for="Product_Name">{{ l('Name') }} *</label>
                                    <input type="text"
                                           #Product_Name="ngModel"
                                           id="Product_Name"
                                           class="form-control"
                                           [(ngModel)]="product.name"
                                           name="Name"
                                           required />
                                    <validation-messages [formCtrl]="Product_Name"></validation-messages>
                                </div>
                            </div>
                            <div class="col-md-3">
                                <div class="form-group">
                                    <label for="Product_AliasName">{{ l('AliasName') }}</label>
                                    <input type="text"
                                           #Product_AliasName="ngModel"
                                           id="Product_AliasName"
                                           class="form-control"
                                           [(ngModel)]="product.aliasName"
                                           name="AliasName" />
                                    <validation-messages [formCtrl]="Product_AliasName"></validation-messages>
                                </div>
                            </div>
                            <div class="col-md-3">
                                <div class="form-group m-form__group">
                                    <label for="UnitName">{{ l('Unit') }}</label>
                                    <select name="product.unitId"
                                            [(ngModel)]="product.unitId"
                                            class="form-select"
                                            required>
                                        <option value="">{{ l('SelectAUnit') }}</option>

                                        <option *ngFor="let item of allUnits" value="{{ item.id }}">
                                            {{ item.displayName }}
                                        </option>
                                    </select>
                                </div>
                            </div>
                            <div class="col-md-4">
                                <div class="form-group m-form__group">
                                    <label for="DepartmentName">{{ l('Department') }}</label>
                                    <select name="product.departmentId"
                                            [(ngModel)]="product.departmentId"
                                            class="form-select"
                                            required>
                                        <option value="">{{ l('SelectADepartment') }}</option>

                                        <option *ngFor="let item of allDepartments" value="{{ item.id }}">
                                            {{ item.displayName }}
                                        </option>
                                    </select>
                                </div>
                            </div>
                            <div class="col-md-4">
                                <div class="form-group m-form__group">
                                    <label for="CategoryName">{{ l('Category') }}</label>
                                    <select name="product.categoryId"
                                            [(ngModel)]="product.categoryId"
                                            class="form-select"
                                            required>
                                        <option value="">{{ l('SelectACategory') }}</option>

                                        <option *ngFor="let item of allCategorys" value="{{ item.id }}">
                                            {{ item.displayName }}
                                        </option>
                                    </select>
                                </div>
                            </div>
                            <div class="col-md-4">
                                <div class="form-group m-form__group">
                                    <label for="SubCategoryName">{{ l('SubCategory') }}</label>
                                    <select name="product.subCategoryId"
                                            [(ngModel)]="product.subCategoryId"
                                            class="form-select">
                                        <option value="">{{ l('SelectASubCategory') }}</option>

                                        <option *ngFor="let item of allSubCategorys" value="{{ item.id }}">
                                            {{ item.displayName }}
                                        </option>
                                    </select>
                                </div>
                            </div>
                            <div class="col-md-4">
                                <div class="form-group m-form__group">
                                    <label for="BrandName">{{ l('Brand') }}</label>
                                    <select name="product.brandId" [(ngModel)]="product.brandId" class="form-select">
                                        <option value="">{{ l('SelectABrand') }}</option>

                                        <option *ngFor="let item of allBrands" value="{{ item.id }}">
                                            {{ item.displayName }}
                                        </option>
                                    </select>
                                </div>
                            </div>
                            <div class="col-md-4">
                                <div class="form-group m-form__group">
                                    <label for="VendorName">{{ l('Vendor') }}</label>
                                    <select name="product.vendorId" [(ngModel)]="product.vendorId" class="form-select">
                                        <option value="">{{ l('SelectAVendor') }}</option>

                                        <option *ngFor="let item of allVendors" value="{{ item.id }}">
                                            {{ item.displayName }}
                                        </option>
                                    </select>
                                </div>
                            </div>
                            <div class="col-md-4">
                                <div class="form-group m-form__group">
                                    <label for="TaxName">{{ l('Tax') }}</label>
                                    <select name="product.taxId" [(ngModel)]="product.taxId" class="form-select">
                                        <option value="">{{ l('SelectATax') }}</option>

                                        <option *ngFor="let item of allTaxs" value="{{ item.id }}">
                                            {{ item.displayName }}
                                        </option>
                                    </select>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-8">
                                <div class="row">
                                    <div class="col-md-4">
                                        <div class="form-group">
                                            <label for="Product_UnitCost">{{ l('UnitCost') }}</label>
                                            <input type="number"
                                                   #Product_UnitCost="ngModel"
                                                   id="Product_UnitCost"
                                                   class="form-control"
                                                   [(ngModel)]="product.unitCost"
                                                   name="UnitCost" />
                                            <validation-messages [formCtrl]="Product_UnitCost"></validation-messages>
                                        </div>
                                    </div>
                                    <div class="col-md-4">
                                        <div class="form-group">
                                            <label for="Product_MRP">{{ l('MRP') }}</label>
                                            <input type="number"
                                                   #Product_MRP="ngModel"
                                                   id="Product_MRP"
                                                   class="form-control"
                                                   [(ngModel)]="product.mrp"
                                                   name="MRP" />
                                            <validation-messages [formCtrl]="Product_MRP"></validation-messages>
                                        </div>
                                    </div>
                                    <div class="col-md-4">
                                        <div class="form-group">
                                            <label for="Product_Price">{{ l('Price') }}</label>
                                            <input type="number"
                                                   #Product_Price="ngModel"
                                                   id="Product_Price"
                                                   class="form-control"
                                                   [(ngModel)]="product.price"
                                                   name="Price" />
                                            <validation-messages [formCtrl]="Product_Price"></validation-messages>
                                        </div>
                                    </div>
                                    <div class="col-md-4">
                                        <div class="form-group">
                                            <label for="Product_SpecialPrice">{{ l('SpecialPrice') }}</label>
                                            <input type="number"
                                                   #Product_SpecialPrice="ngModel"
                                                   id="Product_SpecialPrice"
                                                   class="form-control"
                                                   [(ngModel)]="product.specialPrice"
                                                   name="SpecialPrice" />
                                            <validation-messages [formCtrl]="Product_SpecialPrice"></validation-messages>
                                        </div>
                                    </div>
                                    <div class="col-md-4">
                                        <div class="form-group">
                                            <label for="Product_MinimumSellingPrice">
                                                {{ l('MinimumSellingPrice') }}
                                            </label>
                                            <input type="number"
                                                   #Product_MinimumSellingPrice="ngModel"
                                                   id="Product_MinimumSellingPrice"
                                                   class="form-control"
                                                   [(ngModel)]="product.minimumSellingPrice"
                                                   name="MinimumSellingPrice" />
                                            <validation-messages [formCtrl]="Product_MinimumSellingPrice"></validation-messages>
                                        </div>
                                    </div>
                                    <div class="col-md-4">
                                        <div class="form-group">
                                            <label for="Product_AverageCost">{{ l('AverageCost') }}</label>
                                            <input type="number"
                                                   #Product_AverageCost="ngModel"
                                                   id="Product_AverageCost"
                                                   class="form-control"
                                                   [(ngModel)]="product.averageCost"
                                                   name="AverageCost" />
                                            <validation-messages [formCtrl]="Product_AverageCost"></validation-messages>
                                        </div>
                                    </div>
                                    <div class="col-md-4">
                                        <div class="form-group">
                                            <label for="Product_LastPurchaseCost">{{ l('LastPurchaseCost') }}</label>
                                            <input type="number"
                                                   #Product_LastPurchaseCost="ngModel"
                                                   id="Product_LastPurchaseCost"
                                                   class="form-control"
                                                   [(ngModel)]="product.lastPurchaseCost"
                                                   name="LastPurchaseCost" />
                                            <validation-messages [formCtrl]="Product_LastPurchaseCost"></validation-messages>
                                        </div>
                                    </div>
                                    <div class="col-md-4">
                                        <div class="form-group">
                                            <label for="Product_HSNCode">{{ l('HSNCode') }}</label>
                                            <input type="text"
                                                   #Product_HSNCode="ngModel"
                                                   id="Product_HSNCode"
                                                   class="form-control"
                                                   [(ngModel)]="product.hsnCode"
                                                   name="HSNCode" />
                                            <validation-messages [formCtrl]="Product_HSNCode"></validation-messages>
                                        </div>
                                    </div>
                                    <div class="col-md-4">
                                        <div class="form-group">
                                            <label for="Product_ProductType">{{ l('ProductType') }}</label>
                                            <select #Product_ProductType="ngModel" class="form-select" name="ProductType"
                                                    id="Product_ProductType" [(ngModel)]="product.productType">
                                                <option value="1">{{ l('Normal') }}</option>
                                                <option value="2">{{ l('Consignment') }}</option>
                                                <option value="3">{{ l('SerialNumber') }}</option>
                                                <option value="4">{{ l('Bulk') }}</option>
                                                <option value="5">{{ l('Repack') }}</option>
                                                <option value="6">{{ l('Service') }}</option>
                                                <option value="7">{{ l('RawMaterial') }}</option>
                                                <option value="8">{{ l('Production') }}</option>
                                                <option value="9">{{ l('SemiFinished') }}</option>
                                            </select>
                                            <validation-messages [formCtrl]="Product_ProductType"></validation-messages>
                                        </div>
                                    </div>
                                    <div class="col-md-4">
                                        <br />
                                        <br />
                                        <label class="form-check form-check-custom form-check-solid">
                                            <input id="Product_IsActive"
                                                   #Product_IsActive="ngModel"
                                                   name="IsActive"
                                                   [(ngModel)]="product.isActive"
                                                   type="checkbox"
                                                   class="form-check-input" />
                                            <span class="form-check-label">
                                                {{ l('IsActive') }}
                                            </span>
                                        </label>
                                        <validation-messages [formCtrl]="Product_IsActive"></validation-messages>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-4">
                                <div class="container">
                                    <label>Barcode</label>
                                    <select multiple [(ngModel)]="selectedBarcodes" class="form-control" size="6">
                                        <option *ngFor="let item of product.productBarcodes" [ngValue]="item">
                                            {{ item.barcode }}
                                        </option>
                                    </select>

                                    <label class="mt-2">Operations</label>
                                    <input type="text"
                                           [(ngModel)]="newBarcode"
                                           placeholder="Barcode"
                                           class="form-control" />

                                    <div class="btn-group mt-2 float-end">
                                        <button (click)="addBarcode()" class="btn btn-sm btn-primary">ADD</button>
                                        <button (click)="deleteSelected()" class="btn btn-sm btn-danger">DELETE</button>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-12">
                                <div class="form-group">
                                    <label for="Product_Remarks">{{ l('Remarks') }}</label>
                                    <input type="text"
                                           #Product_Remarks="ngModel"
                                           id="Product_Remarks"
                                           class="form-control"
                                           [(ngModel)]="product.remarks"
                                           name="Remarks" />
                                    <validation-messages [formCtrl]="Product_Remarks"></validation-messages>
                                </div>
                            </div>
                        </div>
                    </tab>
                    <tab heading="{{ 'Stock' | localize }}" *ngIf="true">
                        <div class="row">
                            <div class="col-xl-12">
                                <table class="table table-bordered table-hover" style="margin-top:20px">
                                    <thead>
                                        <tr>
                                            <th width="200px">{{ l('Location') }}</th>
                                            <th width="100px">{{ l('AverageCost') }}</th>
                                            <th width="100px">{{ l('LastPurchaseCost') }}</th>
                                            <th width="100px">{{ l('QtyOnHand') }}</th>
                                            <!--<th width="100px">{{ l('OrderedQuantity') }}</th>
                                            <th width="100px">{{ l('InTransit') }}</th>
                                            <th width="100px">{{ l('ReservedQty') }}</th>
                                            <th width="100px">{{l('ActualQty')}}</th>-->
                                            <th width="100px">{{l('MinimumQty')}}</th>
                                            <th width="100px">{{l('MaximumQty')}}</th>
                                            <th width="100px">{{l('ReorderLevel')}}</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr *ngFor="let item of product.productLocations">
                                            <td><b>{{item.locationCode}}</b></td>
                                            <td class="text-end">{{item.averageCost}}</td>
                                            <td class="text-end">{{item.lastPurchaseCost}}</td>
                                            <td class="text-end"><b>{{item.qtyOnHand}}</b></td>
                                            <!--<td class="text-end">0</td>
                                            <td class="text-end">0</td>
                                            <td class="text-end">0</td>
                                            <td class="text-end">252</td>-->
                                            <td><input type="number" id="MinimumQty" [(ngModel)]="item.minimumQty" class="form-control" name="MinimumQty" /></td>
                                            <td><input type="number" id="MaximumQty" [(ngModel)]="item.maximumQty" class="form-control" name="MaximumQty" /></td>
                                            <td><input type="number" id="ReorderLevel" [(ngModel)]="item.reOrderLevel" class="form-control" name="ReorderLevel" /></td>
                                        </tr>
                                        <tr >
                                            <td></td>
                                            <td class="text-end"></td>
                                            <td class="text-end"><b>{{l('Total')}}</b></td>
                                            <td class="text-end"><b>{{this.totalQtyOnHand}}</b></td>
                                            <!--<td class="text-end">0</td>
                                            <td class="text-end">0</td>
                                            <td class="text-end">0</td>
                                            <td class="text-end">252</td>-->
                                            <td></td>
                                            <td></td>
                                            <td></td>
                                        </tr>

                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </tab>
                    <tab heading="{{ 'Units' | localize }}">
                        <div class="row mt-3">
                            <div class="col-md-12">
                                <table class="table table-bordered">
                                    <thead>
                                        <tr>
                                            <th width="10%">#</th>
                                            <th width="20%">{{ l('Unit') }}</th>
                                            <th width="10%">{{ l('Add') }}</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr *ngFor="let item of product.productUnitMappings; let i = index">
                                            <td class="text-center">
                                                <button (click)="removeUnitMapping(i)"
                                                        class="btn btn-danger d-flex align-items-center justify-content-center p-0 rounded-circle"
                                                        style="width: 30px; height: 30px">
                                                    <i class="fa fa-close fs-6 p-0 fw-bold"></i>
                                                </button>
                                            </td>
                                            <td>
                                                <select [(ngModel)]="item.unitId"
                                                        name="unit{{ i }}"
                                                        class="form-select"
                                                        required>
                                                    <option value="null">{{ l('SelectAUnit') }}</option>

                                                    <option *ngFor="let item of allCartonUnits" value="{{ item.id }}">
                                                        {{ item.displayName }}
                                                    </option>
                                                </select>
                                            </td>
                                            <td width="10%" class="text-center">
                                                <button class="btn btn-success d-flex align-items-center justify-content-center p-0 rounded-circle"
                                                        (click)="addUnitMapping()"
                                                        style="width: 30px; height: 30px">
                                                    <i class="fa fa-plus fs-6 p-0 fw-bold"></i>
                                                </button>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </tab>
                    <tab heading="{{ 'Productions' | localize }}">
                        <div class="row mt-3">
                            <div class="col-md-12">
                               
                                <table class="table table-bordered">
                                    <thead>
                                        <tr>
                                            <th width="10%">#</th>
                                            <th width="20%">{{ l('ProductName') }}</th>
                                            <th width="20%">{{ l('Unit') }}</th>
                                            <th width="20%">{{ l('Qty') }}</th>
                                            <th width="10%">{{ l('Add') }}</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td colspan="4">
                                                <div class="col-md-4">
                                                    <div class="form-group">
                                                        <label for="Product_ProductType">{{ l('ProductionQty') }}</label>
                                                        <input type="number"
                                                               id="Product_ProductionQty"
                                                               class="form-control"
                                                               [(ngModel)]="product.productionQty"
                                                               name="productionQty" />
                                                    </div>
                                                </div>
                                            </td>

                                        </tr>
                                        <tr *ngFor="let item of product.productRawMaterialMappings; let i = index">
                                            <td class="text-center">
                                                <button (click)="removeRawMaterialMapping(i)"
                                                        class="btn btn-danger d-flex align-items-center justify-content-center p-0 rounded-circle"
                                                        style="width: 30px; height: 30px">
                                                    <i class="bi bi-dash fs-6 pe-0 fw-bold"></i>
                                                </button>
                                            </td>
                                            <td>
                                                <select [(ngModel)]="item.productId"
                                                        name="unit{{ i }}"
                                                        class="form-select"
                                                        required>
                                                    <option value="null">{{ l('SelectRawMaterial') }}</option>

                                                    <option *ngFor="let item of allRawMaterials" value="{{ item.id }}">
                                                        {{ item.displayName }}
                                                    </option>
                                                </select>
                                            </td>
                                            <td>
                                                <select [(ngModel)]="item.unitId"
                                                        name="unit{{ i }}"
                                                        class="form-select"
                                                        required>
                                                    <option value="null">{{ l('SelectAUnit') }}</option>

                                                    <option *ngFor="let item of allUnits" value="{{ item.id }}">
                                                        {{ item.displayName }}
                                                    </option>
                                                </select>
                                            </td>
                                            <td>
                                                <input type="number"
                                                       id="Product_LastPurchaseCost"
                                                       class="form-control"
                                                       [(ngModel)]="item.qty"
                                                       name="Qty" />

                                            </td>
                                            <td width="10%" class="text-center">
                                                <button class="btn btn-success d-flex align-items-center justify-content-center p-0 rounded-circle"
                                                        (click)="addRawMaterial()"
                                                        style="width: 30px; height: 30px">
                                                    <i class="bi bi-plus fs-6 p-0 fw-bold"></i>
                                                </button>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </tab>
                    <tab heading="{{ 'PriceGroup' | localize }}">
                        <div class="row mt-3">
                            <p>under development</p>
                        </div>
                    </tab>
                    <tab heading="{{ 'Transactions' | localize }}" *ngIf="true">
                        <div class="row mt-3">
                            <p>under development</p>
                        </div>
                    </tab>
                </tabset>
            </div>
            <div class="card-footer">
                <div class="col-lg-12 text-end">
                    <button (click)="goBack()" class="btn btn-danger me-2" [buttonBusy]="saving">
                        <i class="fa fa-close"></i>
                        <span>{{ l('Close') }}</span>
                    </button>
                    <button
                        (click)="save()"
                        class="btn btn-primary me-2"
                        [buttonBusy]="saving"
                        [busyText]="l('SavingWithThreeDot')"
                    >
                        <i class="fa fa-save"></i>
                        <span>{{ l('Save') }}</span>
                    </button>

                    <button
                        [hidden]="this.product.id"
                        (click)="saveAndNew()"
                        class="btn btn-primary blue float-right"
                        [buttonBusy]="saving"
                        [busyText]="l('SavingWithThreeDot')"
                    >
                        <i class="fa fa-save"></i>
                        <span>{{ l('SaveAndNew') }}</span>
                    </button>
                </div>
            </div>
        </div>
    </div>
</div>
